import "./Unclogging.module.css";
import EnTTe from "@/reusable_sections/Header";
import DBouchageDeDrains from "./sections/DBouchageDeDrains";
import NotreProcessus from "./sections/NotreProcessus";
import DemanderUneIntervention from "./sections/DemanderUneIntervention";
import PiedDePage from "@/reusable_sections/Footer";
export default function UncloggingPage() {
  return <div>
      <EnTTe />
      <DBouchageDeDrains />
      <NotreProcessus />
      <DemanderUneIntervention />
      <PiedDePage />
    </div>;
}